var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiBotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08182 5.50781H9.9186C11.26 5.50781 12.0941 6.45419 12.0941 7.79427V10.4395C12.0941 11.7796 11.26 12.726 9.91793 12.726H6.08182C4.74106 12.726 3.90625 11.7796 3.90625 10.4395V7.79427C3.90625 6.45419 4.74495 5.50781 6.08182 5.50781Z",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09766 10.1826C7.69892 10.4454 8.30026 10.4454 8.90152 10.1826",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47168 7.83967V7.83301",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52832 7.83967V7.83301",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90636 7.83301H3.74939C3.0735 7.83301 2.52539 8.38047 2.52539 9.05634C2.52539 9.73227 3.0735 10.2803 3.74939 10.2803H3.90636",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0938 7.83301H12.2514C12.9273 7.83301 13.4747 8.38047 13.4747 9.05634C13.4747 9.73227 12.9273 10.2803 12.2514 10.2803H12.0938",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82302 3.32313C8.82302 2.86843 8.45462 2.5 7.99989 2.5C7.54522 2.5 7.17676 2.86843 7.17676 3.32313C7.17676 3.77784 7.54522 4.14633 7.99996 4.14633C8.45462 4.14633 8.82302 3.77784 8.82302 3.32313Z",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.50637V4.14551",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77246 14.5H10.2293",
    stroke: "#8959E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBotIcon);
export default __webpack_public_path__ + "static/media/AiBotIcon.c66bac77c302ddb597aad0e3ea5a540f.svg";
export { ForwardRef as ReactComponent };